<template>
  <div v-if="isLoaded">
    <div
      class="content-body"
      v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card" style="">
            <div class="card-header">
              <h4 class="card-title">Inclusão Ocorrências</h4>
              <a class="heading-elements-toggle"
                ><i
                  class="fa fa-ellipsis-v font-medium-3"
                  @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"
                ></i
              ></a>
              <div
                class="heading-elements"
                v-bind:class="{
                  visible: getSubMenuShowHideFw(),
                  '': !getSubMenuShowHideFw(),
                }"
              >
                <ul class="list-inline mb-0">
                  <li>
                    <a
                      @click="onCreate()"
                      v-b-tooltip
                      title="Cadastrar"
                      v-if="
                        this.$refs.vuetable &&
                        this.$refs.vuetable.selectedTo.length > 0
                      "
                      ><i class="fa fa-plus"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterReset()"
                      v-b-tooltip
                      title="Atualizar listagem"
                      ><i class="ft-rotate-cw"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreenFw()"
                      v-b-tooltip
                      title="Expande a tela"
                      v-if="!isFullscreen"
                      ><i class="ft-maximize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreenFw()"
                      v-b-tooltip
                      title="Minimiza a tela"
                      v-if="isFullscreen"
                      ><i class="ft-minimize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterShowHideFw()"
                      v-b-tooltip.hover.left="'Filtros'"
                      ><i class="fa fa-filter"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onActivateDesactivate(1, null, false)"
                      v-b-tooltip
                      title="Ativar Registros"
                      v-if="getPermissionFw('parambanco.status')"
                      ><i class="fa fa-thumbs-o-up"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onActivateDesactivate(2, null, false)"
                      v-b-tooltip
                      title="Inutilizar Registros"
                      v-if="getPermissionFw('parambanco.status')"
                      ><i class="fa fa-thumbs-o-down"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-content">
              <div class="table-responsive">
                <div v-if="vuetableFilterRow">
                  <vuetable-filterbar> </vuetable-filterbar>
                </div>
                <div class="loadingDataPosition">
                  <div class="loadingData" v-if="loadingData">
                    <div class="loadingDataSpinner">
                      <spinner
                        v-if="loadingData"
                        text-fg-color="#ffffff"
                        message="Carregando..."
                      ></spinner>
                    </div>
                  </div>
                  <div>
                    <a
                      @click="searchAll()"
                      v-b-tooltip
                      title="Selecionar todas as páginas"
                      v-if="getPermissionFw('inclusaoocorrencia.index')"
                      ><i
                        class="fa fa-check-square-o fa-lg"
                        style="margin: 0px 0px 5px 4px"
                      ></i
                    ></a>
                  </div>
                  <vuetable
                    ref="vuetable"
                    api-url="/api/inclusaoocorrencia"
                    :fields="fields"
                    :css="css"
                    :append-params="moreParams"
                    track-by="docfis_id"
                    pagination-path=""
                    @vuetable:load-error="onError"
                    @vuetable:pagination-data="onPaginationData"
                    @vuetable:cell-clicked="onDetail"
                    detail-row-component="inclusaoocorrencia-detalhes"
                    @vuetable:loaded="onLoaded"
                  >
                    <template slot="cd_ocorrencia" slot-scope="props">
                      <span v-if="props.rowData.carga_ocorrencia.length > 0">{{
                        props.rowData.carga_ocorrencia[0].param_ocorrencia.cd
                      }}</span>
                    </template>
                    <template slot="num_doc" slot-scope="props">
                      <span
                        v-if="
                          props.rowData.carga_doc != null &&
                          props.rowData.carga_doc.doc_carga_doc != null
                        "
                        >{{
                          props.rowData.carga_doc.doc_carga_doc.doc.num_fiscal
                        }}</span
                      >
                    </template>
                    <template slot="fornecedor" slot-scope="props">
                      <span
                        v-if="
                          props.rowData.doc_fiscal_partes_env.emi_nome != null
                        "
                        >{{
                          props.rowData.doc_fiscal_partes_env.emi_nome
                        }}</span
                      >
                    </template>
                    <template slot="manifesto" slot-scope="props">
                      <span
                        v-if="
                          props.rowData.carga_doc != null &&
                          props.rowData.carga_doc.carga != null &&
                          props.rowData.carga_doc.carga.manifesto != null
                        "
                        >{{
                          props.rowData.carga_doc.carga.manifesto.num_fiscal
                        }}</span
                      >
                    </template>
                    <template slot="redespacho" slot-scope="props">
                      <span
                        v-if="
                          props.rowData.doc_fiscal_partes_env.red_nome != null
                        "
                        >{{
                          props.rowData.doc_fiscal_partes_env.red_nome
                        }}</span
                      >
                    </template>
                    <template slot="destinatario" slot-scope="props">
                      <span
                        v-if="
                          props.rowData.doc_fiscal_partes_env.des_nome != null
                        "
                        >{{
                          props.rowData.doc_fiscal_partes_env.des_nome
                        }}</span
                      >
                    </template>
                    <template slot="red_cnpj" slot-scope="props">
                      <span
                        v-if="
                          props.rowData.doc_fiscal_partes_env.red_cnpj != null
                        "
                        >{{
                          props.rowData.doc_fiscal_partes_env.red_cnpj.replace(
                            /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                            "$1.$2.$3/$4-$5"
                          )
                        }}</span
                      >
                    </template>
                    <template slot="num_carga" slot-scope="props">
                      <span v-if="props.rowData.last_num_carga_isend != null">{{
                        props.rowData.last_num_carga_isend
                      }}</span>
                    </template>
                    <template slot="cd_ocorencia" slot-scope="props">
                      <span v-if="props.rowData.carga_ocorrencia.length > 0">{{
                        props.rowData.carga_ocorrencia[0].param_ocorrencia.cd
                      }}</span>
                    </template>
                    <template slot="descr_ocorrencia" slot-scope="props">
                      <span v-if="props.rowData.carga_ocorrencia.length > 0">{{
                        props.rowData.carga_ocorrencia[0].param_ocorrencia.descr
                      }}</span>
                    </template>
                    <template slot="dt_ocorrencia" slot-scope="props">
                      <span v-if="props.rowData.carga_ocorrencia.length > 0">{{
                        props.rowData.carga_ocorrencia[0].dt_ocorrencia
                      }}</span>
                    </template>
                    <template slot="usuario_ocorrencia" slot-scope="props">
                      <span v-if="props.rowData.carga_ocorrencia.length">
                       {{ obterNomeOuEmailDoUsuario(props.rowData.carga_ocorrencia[0]) }}
                      </span>
                    </template>
                    <template slot="status" slot-scope="props">
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.status.valor == 1"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.status.valor == 2"
                        >{{ props.rowData.status.descr }}</span
                      >
                    </template>
                    <template slot="actions" slot-scope="props">
                      <div class="custom-actions">
                        <a
                          @click="onCreate(props.rowData.docfis_id)"
                          v-b-tooltip
                          title="Cadastrar Ocorrência"
                          ><i class="fa fa-exclamation-triangle"></i
                        ></a>
                        <span>
                          <a
                            v-if="props.rowData.status.valor == 2"
                            @click="
                              onActivateDesactivate(1, props.rowData, true)
                            "
                            v-b-tooltip
                            title="Ativar"
                            ><i class="fa fa-thumbs-o-up"></i
                          ></a>
                          <a
                            v-if="props.rowData.status.valor == 1"
                            @click="
                              onActivateDesactivate(2, props.rowData, true)
                            "
                            v-b-tooltip
                            title="Inativar"
                            ><i class="fa fa-thumbs-o-down"></i
                          ></a>
                          <a
                            @click="onDetail(props.rowData, null, null)"
                            v-b-tooltip
                            title="Ver detalhes"
                            ><i class="fa fa-plus"></i
                          ></a>
                        </span>
                      </div>
                    </template>
                  </vuetable>
                </div>
                <div>
                  <div class="col-md-12">
                    <div class="pull-left pagination-detail">
                      <vuetable-pagination-info
                        ref="paginationInfo"
                        :css="css.pagination"
                        info-class="pull-left"
                      ></vuetable-pagination-info>
                    </div>
                    <div class="pull-right m-a-0">
                      <vuetable-pagination
                        ref="pagination"
                        :css="css.pagination"
                        @vuetable-pagination:change-page="onChangePage"
                      ></vuetable-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <OcorrenciaForm ref="ocorrenciaform" />
    </div>
  </div>
</template>
<script>
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import OcorrenciaFilterBar from "./InclusaoOcorrenciaFilterBar.vue";
import OcorrenciaForm from "./InclusaoOcorrenciaForm.vue";
import InclusaoOcorrenciaDetalhes from "./InclusaoOcorrenciaDetalhes.vue";
import moment from "moment";
import { reduce } from "lodash";

Vue.component("inclusaoocorrencia-detalhes", InclusaoOcorrenciaDetalhes);

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    OcorrenciaForm,
    InclusaoOcorrenciaDetalhes,
    "vuetable-filterbar": OcorrenciaFilterBar,
  },
  data() {
    return {
      dataExport: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      filter_data_store: {},
      filtros_form: new Form({
        cd_ocorrencia: "",
        num_fiscal: "",
        emi_nf_ini: "",
        num_carga: "",
        emi_nf_fim: "",
        emi_nome: "",
        emi_cnpj: "",
        red_nome: "",
        red_cnpj: "",
        doc_ini: "",
        doc_fim: "",
        emi_doc_ini: "",
        unidade: "",
        emi_doc_fim: "",
        manifesto: "",
        ocorrencia_ini: "",
        ocorrencia_fim: "",
      }),
      isDisabled: false,
      loadingData: true,
      showModal: false,
      unidadeOptions: [],
      statusOptions: [],
      optionsCodOcorrencia: [],
      optionsParamMotivo: [],
      form: new Form({ docfis: [] }),
      helpForm: new Form({ recordCollection: [], status: "" }),
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "num_fiscal",
          title: "N° Fiscal",
          sortField: "num_fiscal",
        },
        {
          name: "serie",
          title: "Serie",
          sortField: "serie",
        },
        {
          name: "__slot:num_doc",
          title: "N° Documento",
          sortField: "num_doc",
        },
        {
          name: "__slot:manifesto",
          title: "Manifesto",
          sortField: "manifesto",
        },
        {
          name: "__slot:cd_ocorencia",
          title: "Cd.ultima ocorrência cadastrada",
          sortField: "cd_ocorencia",
        },
        {
          name: "__slot:descr_ocorrencia",
          title: "Descrição da ocorrência",
          sortField: "cd_ocorrencia",
        },
        {
          name: "__slot:fornecedor",
          title: "Fornecedor",
          sortField: "cd_ocorencia",
        },
        {
          name: "__slot:redespacho",
          title: "Redespacho",
          sortField: "cd_ocorencia",
        },
        {
          name: "__slot:destinatario",
          title: "Destinatário",
        },
        {
          name: "__slot:red_cnpj",
          title: "CNPJ",
          sortField: "red_cnpj",
        },
        {
          name: "__slot:dt_ocorrencia",
          title: "Data da ocorrência",
          sortField: "dt_ocorrencia",
        },
        {
          name: "__slot:usuario_ocorrencia",
          title: "Ultimo usuário inc.ocorrência",
          sortField: "usuario_ocorrencia",
        },
        {
          name: "__slot:num_carga",
          title: "N° Carga",
          sortField: "num_fiscal",
        },
        {
          name: "__slot:actions", // <----
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
      ],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  mounted() {
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", (e) => this.onFilterReset());
    this.getLivGeral();
  },
  methods: {
    obterNomeOuEmailDoUsuario(cargaOcorrencia) {
      const CTE_CANCELADO = 30

      const strategy = {
        ocorrencia: cargaOcorrencia.param_ocorrencia ? {
          codigo: cargaOcorrencia.param_ocorrencia.cd
        } : null,
        usuarioCancelamento: cargaOcorrencia.doc && cargaOcorrencia.doc.usuario_canc ? {
          email: cargaOcorrencia.doc.usuario_canc.email,
          nome : cargaOcorrencia.doc.usuario_canc.pessoa ? cargaOcorrencia.doc.usuario_canc.pessoa.pessoa_fisica.nome : null
        } : null,
        usuarioIncluido: cargaOcorrencia.usuario_inc ? {
          email: cargaOcorrencia.usuario_inc.email,
          nome : cargaOcorrencia.usuario_inc.pessoa ? cargaOcorrencia.usuario_inc.pessoa.pessoa_fisica.nome : null
        } : null
      };

      if(strategy.ocorrencia && strategy.ocorrencia.codigo == CTE_CANCELADO && strategy.usuarioCancelamento) {
        return strategy.usuarioCancelamento.nome || strategy.usuarioCancelamento.email;
      }

      return strategy.usuarioIncluido.nome || strategy.usuarioIncluido.email;
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    searchAll(data_filter, tipo) {
      // if(this.$refs.vuetable.selectedTo.length > 0){
      //    this.$refs.vuetable.selectedTo = [];
      // }
      if (tipo == 2) {
        this.filter_data_store = data_filter;
      }
      if (tipo != 2) {
        this.loadingData = true;
        console.log("this.filter_data_store");
        console.log(this.filter_data_store);
        if (this.$refs.vuetable.selectedTo.length == 0) {
          this.filtros_form.cd_ocorrencia =
            this.filter_data_store.cd_ocorrencia;
          this.filtros_form.num_fiscal = this.filter_data_store.num_fiscal;
          this.filtros_form.emi_nf_ini = this.filter_data_store.emi_nf_ini;
          this.filtros_form.num_carga = this.filter_data_store.num_carga;
          this.filtros_form.emi_nf_fim = this.filter_data_store.emi_nf_fim;
          this.filtros_form.emi_nome = this.filter_data_store.emi_nome;
          this.filtros_form.emi_cnpj = this.filter_data_store.emi_cnpj;
          this.filtros_form.red_nome = this.filter_data_store.red_nome;
          this.filtros_form.red_cnpj = this.filter_data_store.red_cnpj;
          this.filtros_form.doc_ini = this.filter_data_store.doc_ini;
          this.filtros_form.doc_fim = this.filter_data_store.doc_fim;
          this.filtros_form.emi_doc_ini = this.filter_data_store.emi_doc_ini;
          this.filtros_form.unidade = this.filter_data_store.unidade;
          this.filtros_form.emi_doc_fim = this.filter_data_store.emi_doc_fim;
          this.filtros_form.manifesto = this.filter_data_store.manifesto;
          this.filtros_form.ocorrencia_ini =
            this.filter_data_store.ocorrencia_ini;
          this.filtros_form.ocorrencia_fim =
            this.filter_data_store.ocorrencia_fim;
          this.filtros_form
            .post("/api/inclusaoocorrencia/all")
            .then((response) => {
              new ReturnApi(response, this, true, false, false);
              response.forEach((obj) => {
                this.$refs.vuetable.selectedTo.push(parseFloat(obj));
              });
              this.loadingData = false;
            })
            .catch((errors) => {
              new ReturnApi(errors, this);
              this.loadingData = false;
            });
        } else {
          this.$refs.vuetable.selectedTo = [];
          this.loadingData = false;
        }
      }
    },
    onFilterSet(data_filter) {
      this.loadingData = true;
      this.moreParams = {
        cd_ocorrencia: data_filter.cd_ocorrencia.value,
        unidade: data_filter.unidade.value,
        num_fiscal: data_filter.num_fiscal,
        num_carga: data_filter.num_carga,
        emi_nf_ini: data_filter.emi_nf_ini,
        emi_nf_fim: data_filter.emi_nf_fim,
        emi_nome: data_filter.emi_nome,
        emi_cnpj: data_filter.emi_cnpj,
        red_nome: data_filter.red_nome,
        red_cnpj: data_filter.red_cnpj,
        doc_ini: data_filter.doc_ini,
        doc_fim: data_filter.doc_fim,
        manifesto: data_filter.manifesto,
        emi_doc_ini: data_filter.emi_doc_ini,
        emi_doc_fim: data_filter.emi_doc_fim,
        ocorrencia_ini: data_filter.ocorrencia_ini,
        ocorrencia_fim: data_filter.ocorrencia_fim,
      };
      if (JSON.stringify(this.moreParams) != "{}") {
        this.searchAll(this.moreParams, 2);
      }
      Vue.nextTick(() => {
        this.$refs.vuetable.refresh();
      });
    },
    onFilterReset() {
      this.loadingData = true;
      this.moreParams = {};
      this.$refs.vuetable.selectedTo = [];
      this.filter_data_store = {};
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onLoaded: function () {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingData = false;
      this.$store.commit("setVuetableFilterButton", false);
    },
    onDetail(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.docfis_id);
    },
    onCreate(data) {
      this.form.docfis = [];
      if (this.$refs.vuetable && this.$refs.vuetable.selectedTo.length > 0) {
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.form.docfis.push(obj);
        });
        this.$refs.ocorrenciaform.onCreate(this.form.docfis);
        this.$refs.vuetable.selectedTo = [];
      } else {
        this.form.docfis.push(data);
        // this.form.docfis = data;
        this.$refs.ocorrenciaform.onCreate(this.form.docfis);
      }
    },
    onEdit(data, index) {
      this.id = data.parban_id;
      this.$refs.paramsform.onEdit(data, index, this.id);
    },
    onActivateDesactivate(action, data, tipo) {
      // Tipo = true = Checkbox
      this.helpForm.status = action;
      if (tipo) {
        this.helpForm.recordCollection = [];
        this.helpForm.recordCollection.push(data.parban_id);
      } else {
        this.helpForm.recordCollection = [];
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.helpForm.recordCollection.push(obj);
        });
      }
      this.$refs.paramsform.onActivateDesactivate(this.helpForm);
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    formatDate(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY/MM/DD HH:mm").format(fmt);
    },
    getLivGeral() {
      this.helpForm
        .get("/api/inclusaoocorrencia/jsonlist")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.status.forEach((obj) => {
            this.statusOptions.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
          response.unidade.forEach((obj) => {
            this.unidadeOptions.push({
              label: obj.descr + " - " + obj.cd,
              value: obj.unidade_id,
            });
          });

          response.param_ocorrencia.forEach((obj) => {
            if (obj.cd == 1 &&
              this.getPermissionFw("permitir.incluir.ocorrencia.entrega")){
                this.optionsCodOcorrencia.push({
                  label: obj.cd + " - " + obj.descr,
                  value: obj.parocorren_id,
                });
              } else if (obj.cd !== 1) {
                this.optionsCodOcorrencia.push({
                  label: obj.cd + " - " + obj.descr,
                  value: obj.parocorren_id,
                });
              }
          });

          response.param_motivo.forEach((obj) => {
            this.optionsParamMotivo.push({
              label: obj.descr + " - " + obj.cd,
              value: obj.parmot_id,
            });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
    isFullscreen: {
      get() {
        return this.$store.getters.is_full_screen;
      },
    },
  },
};
</script>
